<app-cta-configuratore></app-cta-configuratore>

<footer id="footer" class="no-print">
  <div class="container-fluid main-footer">
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-3">
          <div class="logo-footer mb-2">
            <img alt="Logo Stem" src="assets/img/logo-stem-bianco.webp">
          </div>
          <div class="social-icons mt-5 mt-md-3 mb-5 mb-md-0" style="min-width: 160px;">
            <button title="Facebook" type="button" (click)='openFacebook()' class="fb-button mx-2 mr-lg-3 ml-lg-0"><i class="fab fa-facebook"></i></button>
            <a aria-label="Linkedin" href="https://www.linkedin.com/company/stem-ems/" target="_blank"><i class="fab fa-linkedin d-inline-flex mx-2 mr-lg-3 ml-lg-0"></i></a>
            <a aria-label="Instagram" href="https://www.instagram.com/stem_ems/" target="_blank"><i class="fab fa-instagram d-inline-flex mx-2 mr-lg-3 ml-lg-0"></i></a>
            <a aria-label="YouTube" href="https://www.youtube.com/channel/UCs6NtZ-STb1daZPdHlO54kw" target="_blank"><i class="fab fa-youtube d-inline-flex mx-2 mr-lg-3 ml-lg-0"></i></a>
          </div>

        </div>
        <div class="col-12 col-md-3" *ngFor="let colonna of footer">
          <ul class="footer-menu">
            <li *ngFor="let voce of colonna.figli">
              <app-footer-voce-menu [voce]="voce"></app-footer-voce-menu>
            </li>
          </ul>
        </div>
        <div class="col-md-3 mt-5 my-md-0 mb-4">
          <form #form="ngForm">
            <div class="form-newsletter">
              <div class="input-group mb-3">
                <input type="text" class="form-control" placeholder="{{'INSERISCI_LA_TUA_MAIL' | translate | htmlToText}}" name="newsletter" [(ngModel)]="email" email required>
                <div class="input-group-append">
                  <button title="{{'ISCRIVITI' | translate | htmlToText}}" [disabled]="form.invalid" class="btn btn-stem-footer" type="button" (click)="newsletter()">{{'ISCRIVITI' | translate | htmlToText}}</button>
                </div>
              </div>
              <div class="form-check">
                <input type="checkbox" class="form-check-input" name="exampleCheck1" id="exampleCheck1" [(ngModel)]="checkPrivacy" required>
                <label class="form-check-label" for="exampleCheck1">{{'FOOTER_CHECK_PRIVACY' | translate | htmlToText}} <span [innerHTML]="'FOOTER_CLICK_COPYRIGHT' | translate"></span></label>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid sub-footer">
    <div class="container">
      <div class="row">
        <div class="col-12 copyright">
          <small>{{'FOOTER_COPYRIGHT' | translate | htmlToText}}</small>
        </div>
      </div>
    </div>
  </div>
</footer>


  <!-- Modal -->
  <div class="modal fade show" [class.d-block]="modalShow" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog mt-5 pt-5" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">{{'ISCRIZIONE_NEWSLETTER_SUCCESS' | translate | htmlToText}}</h5>
          <button title="{{'CHIUDI' | translate | htmlToText}}" type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="modalShow = false">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
    </div>
  </div>
